import { render, staticRenderFns } from "./NormalSearchNav66.vue?vue&type=template&id=6b23e250&scoped=true&"
import script from "./NormalSearchNav66.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav66.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23e250",
  null
  
)

export default component.exports